import { TextField, Stack, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';

export default function InterfaceTypeFields({
  type,
  fields,
  setFields,
  isUpdate = false,
}) {
  const handleChange = (field) => (event) => {
    let value = event.target.value;
    if (field === 'token' && (type === 'tanss' || type === 'tanss-erp')) {
      if (!/^Bearer\s+/i.test(value)) {
        value = 'Bearer ' + value;
      }
    }
    setFields((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const [visible, setVisible] = useState({});

  const toggleVisible = (key) => {
    setVisible((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  switch (type) {
    case 'tanss':
      return isUpdate ? (
        <>
          <TextField
            required
            fullWidth
            label="API Token"
            value={fields.token || ''}
            onChange={handleChange('token')}
          />
          <TextField
            required
            fullWidth
            label="Refresh Token"
            value={fields.refreshToken || ''}
            onChange={handleChange('refreshToken')}
          />
        </>
      ) : (
        <>
          <TextField
            required
            fullWidth
            label="Username"
            value={fields.tanssUsername || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                tanssUsername: e.target.value,
              }))
            }
          />
          <TextField
            required
            fullWidth
            type={visible.tanssPassword ? 'text' : 'password'}
            label="Password"
            value={fields.tanssPassword || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                tanssPassword: e.target.value,
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => toggleVisible('tanssPassword')}
                    edge="end"
                  >
                    {visible.tanssPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            label="2FA Code (Wenn aktiviert)"
            value={fields.twoFactorCode || ''}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 6);
              setFields((prev) => ({
                ...prev,
                twoFactorCode: value,
              }));
            }}
            inputProps={{
              maxLength: 6,
              pattern: '[0-9]*',
              inputMode: 'numeric',
            }}
            placeholder="Geben Sie den 6-stelligen Code ein, wenn 2FA aktiviert ist"
            helperText="Optional: Geben Sie den 6-stelligen Code aus der Authenticator-App ein, wenn 2FA aktiviert ist"
          />
        </>
      );

    case 'tanss-erp':
      return (
        <>
          <TextField
            required
            fullWidth
            label="API Token"
            value={fields.headers?.apiToken || fields.token || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'weclapp':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Authentication Token"
            value={fields.token || fields.headers?.AuthenticationToken || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'vmware':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Visible-Credential-Path"
            value={fields.visibleCredentials?.path || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  path: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Visible-Credential-Host"
            value={fields.visibleCredentials?.host || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  host: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="User"
            value={fields.visibleCredentials?.user || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  user: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            type={visible['visibleCredentials.password'] ? 'text' : 'password'}
            label="Password"
            value={fields.visibleCredentials?.password || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  password: e.target.value,
                },
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => toggleVisible('visibleCredentials.password')}
                    edge="end"
                  >
                    {visible['visibleCredentials.password'] ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </>
      );

    case 'nexmart':
      return (
        <Stack spacing={2}>
          <TextField
            required
            fullWidth
            label="API Key"
            value={fields.headers?.['X-NM-API-KEY'] || fields.token || ''}
            onChange={handleChange('token')}
          />
        </Stack>
      );

    case 'ftp':
      return (
        <>
          <TextField
            required
            fullWidth
            label="User"
            value={fields.user || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                user: e.target.value,
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Password"
            type={visible?.password ? 'text' : 'password'}
            value={fields.password || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => toggleVisible('password')}
                    edge="end"
                  >
                    {visible?.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            required
            fullWidth
            label="Port"
            type="number"
            value={fields.port || '21'}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                port: e.target.value,
              }))
            }
          />
        </>
      );

    case 'backup42':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Username"
            value={fields.username || ''}
            onChange={handleChange('username')}
          />
          <TextField
            required
            fullWidth
            label="Password"
            type={visible?.password ? 'text' : 'password'}
            value={fields.password || ''}
            onChange={handleChange('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => toggleVisible('password')}
                    edge="end"
                  >
                    {visible?.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || fields.token || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'host':
      return (
        <>
          <TextField
            required
            fullWidth
            label="User"
            value={fields.user || ''}
            onChange={handleChange('user')}
          />
          <TextField
            required
            fullWidth
            label="Password"
            type={visible.password ? 'text' : 'password'}
            value={fields.password || ''}
            onChange={handleChange('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => toggleVisible('password')}
                    edge="end"
                  >
                    {visible.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </>
      );

    case 'jira':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || fields.token || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'acronis':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Username"
            value={fields.username || ''}
            onChange={handleChange('username')}
          />
          <TextField
            required
            fullWidth
            label="Password"
            type="password"
            value={fields.password || ''}
            onChange={handleChange('password')}
          />
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || fields.token || ''}
            onChange={handleChange('token')}
          />
        </>
      );
    case 'otto':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Grant Type"
            value={fields.grantType || 'client_credentials'}
            disabled
          />
          <TextField
            required
            fullWidth
            label="Scope"
            value={fields.scope || 'orders products shipments'}
            disabled
          />
          <TextField
            required
            fullWidth
            label="Client Id"
            value={fields.clientId || ''}
            onChange={handleChange('clientId')}
          />
          <TextField
            required
            fullWidth
            label="Client Secret"
            value={fields.clientSecret || ''}
            onChange={handleChange('clientSecret')}
          />
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'paperless':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || fields.token || ''}
            onChange={handleChange('token')}
          />
        </>
      );
    case 'shipcloud':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Username"
            value={fields.auth?.username || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                auth: { ...prev.auth, username: e.target.value },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Username"
            value={fields.auth?.password || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                auth: { ...prev.auth, password: e.target.value },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || ''}
            onChange={handleChange('token')}
          />
        </>
      );

    case 'riverbird':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Error"
            value={fields.error || ''}
            onChange={handleChange('error')}
          />
          <TextField
            required
            fullWidth
            label="Benutzername"
            value={fields.username || ''}
            onChange={handleChange('username')}
          />
          <TextField
            required
            fullWidth
            label="Passwort"
            value={fields.password || ''}
            onChange={handleChange('password')}
          />
          <TextField
            required
            fullWidth
            label="Anwendung"
            value={fields.application || ''}
            onChange={handleChange('application')}
          />
          <TextField
            required
            fullWidth
            label="Gerät"
            value={fields.device || ''}
            onChange={handleChange('device')}
          />
          <TextField
            required
            fullWidth
            label="Body Ticket"
            value={fields.body?.Ticket || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                body: { ...prev.body, Ticket: e.target.value },
              }))
            }
          />
        </>
      );

    case 'ups':
      return (
        <>
          <TextField
            required
            fullWidth
            label="User"
            value={fields.visibleCredentials?.user || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  user: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Auth Protocol"
            value={fields.visibleCredentials?.authProtocol || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  authProtocol: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Auth Key"
            value={fields.visibleCredentials?.authKey || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  authKey: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Private Protocol"
            value={fields.visibleCredentials?.privProtocol || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  privProtocol: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Private Key"
            value={fields.visibleCredentials?.privKey || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  privKey: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Level"
            value={fields.visibleCredentials?.level || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  level: e.target.value,
                },
              }))
            }
          />
          <TextField
            required
            fullWidth
            label="Port"
            value={fields.visibleCredentials?.port || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                visibleCredentials: {
                  ...prev.visibleCredentials,
                  port: e.target.value,
                },
              }))
            }
          />
        </>
      );
    case 'microsoft':
      return (
        <>
          <TextField
            required
            fullWidth
            label="ClientId"
            value={fields.clientId || ''}
            onChange={handleChange('clientId')}
          />
          <TextField
            required
            fullWidth
            label="Client Secret"
            value={fields.client_secret || ''}
            onChange={handleChange('client_secret')}
          />
          <TextField
            required
            fullWidth
            label="Microsoft Tenant Id"
            value={fields.microsoftTenantId || ''}
            onChange={handleChange('microsoftTenantId')}
          />

          <TextField
            required
            fullWidth
            label="Authorization Token"
            value={fields.headers?.Authorization || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                headers: { ...prev.headers, Authorization: e.target.value },
              }))
            }
          />
        </>
      );

    case 'ai':
      return (
        <>
          <TextField
            required
            fullWidth
            label="Provider"
            value={fields.provider || ''}
            onChange={handleChange('provider')}
          />
          <TextField
            required
            fullWidth
            label="Model Id"
            value={fields.modelId || ''}
            onChange={handleChange('modelId')}
          />
          <TextField
            required
            fullWidth
            label="Currency"
            value={fields.currency || ''}
            onChange={handleChange('currency')}
          />
        </>
      );

    case 'm365_email':
      return (
        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Mailbox-Ordner (optional)"
            placeholder="Inbox"
            helperText="Lassen Sie dieses Feld leer, um den Posteingang zu überwachen, oder geben Sie einen spezifischen Ordner an (z.B. 'Support', 'Inbox/Subfolder')"
            value={fields.mailboxFolder || ''}
            onChange={(e) =>
              setFields((prev) => ({
                ...prev,
                mailboxFolder: e.target.value,
              }))
            }
          />
        </Stack>
      );

    default:
      return null;
  }
}
